export function reportSalesByProducts(idProduto, startDate, endDate) {
  const token = localStorage.getItem("token");
  salesByProducts(token, idProduto, startDate, endDate)
}

function salesByProducts(token, idProduto, startDate, endDate) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/report/produtos-vendas?idProduto=${idProduto}&auth=${token}&startDate=${startDate}&endDate=${endDate}`
  );
}